import { Box, IconButton, List, ListItem, ListItemText, TextField } from "@material-ui/core";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import { path } from "ramda";
import { ChangeEvent, FC, useEffect, useState } from "react";
import { useListContext } from "react-admin";

import { Query } from "../../types/firebase.types";
import { GenericFunction, GenericObject } from "../../types/generic.types";
import { truncateText } from "../../utils/generic";
import Loader from "../Loader";

const BaseSearch: FC<BaseSearchProps> = (props) => {
  const { query, source, label, initialData = [], getData, onSelect, onClose, limit = 10 } = props;
  const context = useListContext();

  const [items, setItems] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [value, setValue] = useState(path([source])(context.filterValues));

  const getQuery = (value: string) =>
    query
      .orderBy(source)
      .startAt(value || "")
      .endAt(`${value || ""}\uf8ff`)
      .limit(limit);

  const handleChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
    const typedValue = e.target.value;
    setValue(typedValue);
    setIsMenuOpen(true);
    setLoading(true);

    getData(getQuery(typedValue), typedValue, source).subscribe({
      next(data: any[]) {
        setItems(data);
        setLoading(false);
      },
    });
  };

  const handleSelect = (selection: GenericObject) => {
    setValue(path<string>(source.split("."))(selection));
    onSelect(selection);
    setIsMenuOpen(false);
  };

  useEffect(() => {
    setItems(initialData);
  }, []);

  return (
    <Box position="relative">
      <TextField
        variant="outlined"
        size="small"
        label={label}
        value={value}
        onChange={handleChangeSearch}
        InputLabelProps={{ shrink: !!value }}
        onBlur={() => {
          setTimeout(() => {
            setIsMenuOpen(false);
          }, 200);
        }}
        style={{
          position: "relative",
          marginBottom: 8,
        }}
      />
      <Box
        sx={{
          position: "absolute",
          top: 0,
          right: 0,
          zIndex: 100,
          margin: 2,
          width: 50,
          height: 35,
          display: "flex",
          justifyContent: "center",
        }}
        style={{
          backgroundColor: "#eee",
        }}
      >
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
        >
          <HighlightOffIcon />
        </IconButton>
      </Box>
      <List
        disablePadding
        style={{
          position: "absolute",
          width: "100%",
          top: 45,
          zIndex: 100,
          backgroundColor: "white",
          boxShadow: "1px 1px 5px grey",
        }}
      >
        <Loader loading={loading} height="50px">
          {isMenuOpen ? (
            items.length > 0 ? (
              items.map((item: any) => (
                <ListItem button onClick={() => handleSelect(item)}>
                  <ListItemText>{truncateText(path(source.split("."))(item as any) as string)}</ListItemText>
                </ListItem>
              ))
            ) : (
              <ListItem>No results found!</ListItem>
            )
          ) : null}
        </Loader>
      </List>
    </Box>
  );
};

interface BaseSearchProps {
  query: Query;
  source: string;
  label: string;
  initialData?: any[];
  getData: GenericFunction;
  onSelect: GenericFunction;
  onClose: GenericFunction;
  limit?: number;
  alwaysOn?: boolean;
}

export default BaseSearch;
